import { render, staticRenderFns } from "./title-return.vue?vue&type=template&id=d8860aaa&scoped=true&"
import script from "./title-return.vue?vue&type=script&lang=js&"
export * from "./title-return.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8860aaa",
  null
  
)

export default component.exports